export default __webpack_public_path__ + "locales/sq-AL/SingleSignOn.json?hash=9398e4c462822fc17aa6762e5c939584";